export class SeoUrls {
    public static regexGearbox = "^\/(?<usedornew>used|new-vehicles)\/(?<vehicletype>[^\/]+)\/(?<gearboxtype>automatic|manual)\/?$";
    public static regexFueltype = "^\/(?<usedornew>used|new-vehicles)\/(?<vehicletype>[^\/]+)\/(?<fueltype>bi\-fuel|diesel|dual\-fuel|electric|hybrid|lpg|petrol)\/?$";
    public static regexColour = "^\/(?<usedornew>used|new-vehicles)\/(?<vehicletype>[^\/]+)\/(?<colour>black|blue|gold|green|grey|orange|purple|red|silver|white|yellow|beige|other)\/?$";
    public static regexBodyStyle = "^\/(?<usedornew>used|new-vehicles)\/(?<vehicletype>[^\/]+)\/(?<body>3\-wheeler|a\-class|ambulance|beaver\-tail|box\-van|bus|camper\-van|caravan|cdv|chassis\-cab|chiller\-van|coach|combi\-van|convertible|coupe|crew\-cab|crew\-cab\-drop\-side|crew\-cab\-tipper|crew\-van|double\-cab\-pickup|drop\-side\-tipper|drop\-side\-truck|freezer\-van|fridge\-van|hatchback|hearse|high\-top|kit\-car|limousine|luton\-van|lwb\-panel\-van|milk\-float|minibus|motorcycle|motorhome|mpvestate|mwb\-panel\-van|panel\-van|pick\-up|pop\-top|recovery|rv|saloon|spider|spyder|static\-caravan|swb\-panel\-van|temperature\-controlled|tilt\-and\-slide|tipper\-truck|touring\-caravan|truck|van)\/?$";
    public static regexVehicleDetails = "^\/(?<usedornew>used|new-vehicles)\/(?<vehicletype>[^\/]+)\/(?<make>[^-\/]*)-(?<model>[^-\/]*)-(?<derivative>.*-)?(?<id>[0-9_]+)\/?$";
	public static regexVehicleMakeModel = "^\/(?<usedornew>used|new-vehicles)\/(?<vehicletype>(?!vehicle)[^\/]*)\/?(?<make>[^\/]*)\/?(?<model>[^\/]*)\/?$";
	
	public static getSeoUrlParms(urlPathname: string, isWebsectionOrBranchUrl: boolean = false): {[index: string]: string} {
		return (isWebsectionOrBranchUrl) ? SeoUrls.getWebsectionUrlParms(urlPathname) : SeoUrls.getSeoUrlParms_(urlPathname);
	}

	private static getWebsectionUrlParms(urlPathname: string): {[index: string]: string} {
		const websectionSlugifiedName = urlPathname.split('/').filter(s=>s.length > 0).pop();

        if(websectionSlugifiedName == "") {
            return {}; // default - no match
        } else {
			return { websection: websectionSlugifiedName };
		}
	}

    private static getSeoUrlParms_(urlPathname: string): {[index: string]: string} {
        var urlRegexes = [ this.regexGearbox, // gearbox
                this.regexFueltype, // fueltype
                this.regexColour, // colour
                this.regexBodyStyle, // body style
                this.regexVehicleDetails, // used vehicle details
                this.regexVehicleMakeModel // used vehicle listings
             ];
               
        // return first match
        for(var i=0; i<urlRegexes.length; i++)
        {
            var match = this.matchGroupedRegex(urlRegexes[i], urlPathname);
    
            if(match.matched === true) {
                return match.groups;
            }
        }
        
        return {}; // default (no match)
    }

    private static extractRegExGroupNames(regexStr: string): string[] {
		var groupNames = [];

		var reGroupNames = new RegExp(/(<[^>]+>)/g);
		var reGroupNamesMatch = reGroupNames.exec(regexStr);

		while(reGroupNamesMatch != null) {
			var groupName = reGroupNamesMatch[0].replace(/<|>/g, '');
			groupNames.push(groupName);
			
			reGroupNamesMatch = reGroupNames.exec(regexStr);
		};

		return groupNames;
	}

	private static matchGroupedRegex(regexStr: string, matchStr: string): { matched: boolean, originalMatch: RegExpExecArray | null, groups: {[index: string]: string} } {
		// replace group names with basic groups (index based) - chrome only just about supports named groups currently and other browsers don't at all
		var basicGroupRegexStr = regexStr.replace(/\?<[^>]+>/g, '');
		var re = new RegExp(basicGroupRegexStr, "g");
		var match = re.exec(matchStr); 

		var groupedMatch: { matched: boolean, originalMatch: RegExpExecArray | null, groups: {[index: string]: string} } = {
			matched: (match !== null),
			originalMatch: match,
			groups: {}
		};

		var groupNames = this.extractRegExGroupNames(regexStr);
		
		for(var i=1; i<=groupNames.length; i++) {
			var grpName = groupNames[i-1];
		
			groupedMatch.groups[grpName] = (match !== null && match[i] != null && match[i].length > 0) ? decodeURI(match[i]) : '' ;
		}

		return groupedMatch;
	}
}

